"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperimposedDivs = exports.FlexItemClassName = exports.FillRemainingSpaceClassName = exports.FlexItem = exports.VerticalContainerClassName = exports.HorizontalContainerClassName = exports.FillParentClassName = exports.VerticalFlexContainer = exports.HorizontalFlexContainer = exports.divWithStyle = exports.errorNameContainsSpaces = void 0;
var react_1 = __importDefault(require("react"));
var LayoutStyles_1 = require("./LayoutStyles");
var StyleFunctions_1 = require("./StyleFunctions");
exports.errorNameContainsSpaces = 'DivWithStyle component name may not contain spaces';
function divWithStyle(nameForComponentAndCssClass, styles, definedDivProps) {
    var _a;
    if (nameForComponentAndCssClass.indexOf(' ') > -1) {
        throw new Error(exports.errorNameContainsSpaces);
    }
    if (!Array.isArray(styles)) {
        styles = [styles];
    }
    var className = StyleFunctions_1.cssClass.apply(void 0, __spreadArray([nameForComponentAndCssClass], styles, false));
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.render = function () {
                var divPropsWithClassName = __assign(__assign(__assign({}, definedDivProps), this.props), { className: className });
                return (react_1.default.createElement("div", __assign({}, divPropsWithClassName), this.props.children));
            };
            return class_1;
        }(react_1.default.Component)),
        _a.displayName = nameForComponentAndCssClass,
        _a;
}
exports.divWithStyle = divWithStyle;
function HorizontalFlexContainer(props) {
    var classNames = StyleFunctions_1.classes.apply(void 0, __spreadArray([exports.HorizontalContainerClassName,
        props.fillFlexParent && exports.FillParentClassName], (props.additionalClassNames || []), false));
    return react_1.default.createElement("div", { className: classNames }, props.children);
}
exports.HorizontalFlexContainer = HorizontalFlexContainer;
function VerticalFlexContainer(props) {
    var classNames = StyleFunctions_1.classes.apply(void 0, __spreadArray([exports.VerticalContainerClassName,
        props.fillFlexParent && exports.FillParentClassName], (props.additionalClassNames || []), false));
    return react_1.default.createElement("div", { className: classNames }, props.children);
}
exports.VerticalFlexContainer = VerticalFlexContainer;
exports.FillParentClassName = 'fill-flex-parent';
var flexContainerContainerClass = function (name, direction) {
    var _a;
    return (0, StyleFunctions_1.cssClass)(name, {
        display: 'flex',
        flexDirection: direction,
        $nest: (_a = {},
            _a["&.".concat(exports.FillParentClassName)] = {
                flex: 1,
            },
            _a)
    });
};
exports.HorizontalContainerClassName = flexContainerContainerClass('horizontal-flex-container', 'row');
exports.VerticalContainerClassName = flexContainerContainerClass('vertical-flex-container', 'column');
function FlexItem(props) {
    var classNames = (0, StyleFunctions_1.classes)(exports.FlexItemClassName, props.fillRemainingSpace && exports.FillRemainingSpaceClassName);
    return react_1.default.createElement("div", { className: classNames }, props.children);
}
exports.FlexItem = FlexItem;
exports.FillRemainingSpaceClassName = 'fill-remaining-space';
exports.FlexItemClassName = (0, StyleFunctions_1.cssClass)('flex-item', {
    $nest: (_a = {},
        _a["&.".concat(exports.FillRemainingSpaceClassName)] = {
            flexGrow: 1,
        },
        _a)
});
var superimposedDivsContainerClass = (0, StyleFunctions_1.cssClass)('superimposedDivsContainer', {
    height: '100%',
    position: 'relative',
});
/**
 * Renders each child inside its own absolutely-positioned div, all superimposed directly on top of one another.
 * Positions itself to fill its container height.
 */
function SuperimposedDivs(props) {
    var childItems = (props.children instanceof Array) ? props.children : [props.children];
    var filteredChildItems = childItems.filter(function (item) { return item !== null; });
    return (react_1.default.createElement("div", { className: superimposedDivsContainerClass }, filteredChildItems.map(function (item) { return (react_1.default.createElement("div", { className: LayoutStyles_1.absolutePositionFill, key: item.key || undefined }, item)); })));
}
exports.SuperimposedDivs = SuperimposedDivs;
//# sourceMappingURL=LayoutComponents.js.map